import React, { Component } from 'react';

import _ from 'lodash';

import { connect } from 'react-redux';

import Paper from '@material-ui/core/Paper';

import ActionBar from '../../components/ActionBar';

import TreeMenuWrapper from './TreeMenuWrapper';

import * as ArchitectActions from '../../actions/architectActions';
import * as ClientActions from '../../actions/clientActions';
import * as CoreActions from '../../actions/coreActions';
import * as HomeActions from '../../actions/homeActions';
import * as SiteActions from '../../actions/siteActions';
import * as SvcRequestActions from '../../actions/svcRequestActions';

import classes from './TreePanel.module.css';

class TreePanel extends Component {

    async componentDidMount() {
        const {
            companyInfo,
            fetchNodeHealthChecks,
            initializeTree,
            setProgressBarLoading
        } = this.props;

        if (companyInfo.companyId) {
            await initializeTree(companyInfo);
            await fetchNodeHealthChecks({id: companyInfo.companyId, type: 'company'});

            setProgressBarLoading(false);
        } else {
            setProgressBarLoading(false);
        }
    }

    async componentDidUpdate(prevProps) {
        const {
            companyInfo,
            fetchNodeHealthChecks,
            initializeTree,
            setProgressBarLoading
        } = this.props;

        if (prevProps.companyInfo !== companyInfo) {
            await initializeTree(companyInfo);
            await fetchNodeHealthChecks({id: companyInfo.companyId, type: 'company'});

            setProgressBarLoading(false);
        }
    }

    handleSearch = async searchTerm => {
        const { tree, setTree, companyInfo, initializeTree } = this.props;

        if (_.isEmpty(searchTerm)) {
            await initializeTree(companyInfo);

            return;
        }

        const results = [];

        const search = (tree, searchTerm) => {
            return tree.reduce((r, e) => {
                if (e.label.toLowerCase().includes(searchTerm.toLowerCase())) {
                    results.push(e);
                } else {
                    if (e.nodes) search(e.nodes, searchTerm);
                }

                return r;
            }, []);
        };

        search(tree, searchTerm);

        setTree(results);
    }

    handleTreeClick = async node => {
        if (_.isNil(node) || _.isEmpty(node)) return;

        const {
            fetchNodeHealthChecks,
            getCardFaultScores,
            getNodeFaultScore,
            setClient,
            setNode,
            setSite,
            setSiteNode,
            setEquipmentNode,
            setAreaNode,
            setSystemNode,
            setProgressBarLoading
        } = this.props;

        setProgressBarLoading(true);

        setNode(node);

        switch (node.type) {
            case 'company':
            case 'campus':
                await fetchNodeHealthChecks(node);
                await getCardFaultScores(node.id);
                setProgressBarLoading(false);
                break;
            case 'client':
                await fetchNodeHealthChecks(node);
                await getCardFaultScores(node.id);
                setProgressBarLoading(false);
                setClient(node);
                break;
            case 'site':
                setSiteNode(node);
                await fetchNodeHealthChecks(node);
                await getCardFaultScores(node.id);
                setSite(node);
                setProgressBarLoading(false);
                return;
            case 'equipment':
                setProgressBarLoading(false);
                break;
            case 'area':
                setProgressBarLoading(false);
                break;
            case 'system':
                setProgressBarLoading(false);
                break;
            case 'equipmentItem':
                setEquipmentNode(node);
                await fetchNodeHealthChecks(node);
                await getCardFaultScores(node.id);
                await getNodeFaultScore(node.id);
                setProgressBarLoading(false);
                return;
            case 'areaItem':
                setAreaNode(node);
                await fetchNodeHealthChecks(node);
                await getCardFaultScores(node.id);
                await getNodeFaultScore(node.id);
                setProgressBarLoading(false);
                return;
            case 'systemItem':
                setSystemNode(node);
                await fetchNodeHealthChecks(node);
                await getCardFaultScores(node.id);
                await getNodeFaultScore(node.id);
                setProgressBarLoading(false);
                return;
            default:
                break;
        }

    }

    handleTreeToggle = async node => {
        if (_.isNil(node) || _.isEmpty(node)) return;

        const {
            setTree,
            setClient,
            setSite,
            tree,
            fetchSiteChildNodes,
            setProgressBarLoading
        } = this.props;
        const { id, type } = node;
        let data;

        if (node.isOpen) return;

        setProgressBarLoading(true);

        const search = (tree, id, nodes) => {
            return tree.reduce((r, e) => {
                if (e.id === id) {
                    if (Array.isArray(nodes)) e.nodes = [...nodes];
                } else {
                    if (e.nodes) search(e.nodes, id, nodes);
                }

                return r;
            }, []);
        };

        switch (type) {
            case 'client':
                setClient(node);
                break;
            case 'site':
                setSite(node);
                data = await fetchSiteChildNodes(node);

                search(tree, id, data);

                setTree(tree);
                break;
            default:
                break;
        }

        setProgressBarLoading(false);
    }

    render() {
        const {
            onToggleCreateServiceRequestModal,
            onToggleSubscriptionModal,
            prepareServiceCallNode,
            saveTreeReset,
            setSubscription,
            tree
        } = this.props;

        return (
            <Paper className={classes.TreePanel}>
                <div className={classes.actionBarContainer}>
                    <ActionBar
                        onSearch={this.handleSearch}
                    />
                </div>
                <div className={classes.treePot}>
                    <TreeMenuWrapper
                        data={tree}
                        onToggleItem={this.handleTreeToggle}
                        onClickItem={this.handleTreeClick}
                        saveTreeReset={saveTreeReset}
                        onToggleSubscriptionModal={onToggleSubscriptionModal}
                        onToggleCreateServiceRequestModal={onToggleCreateServiceRequestModal}
                        setSubscription={setSubscription}
                        prepareServiceCallNode={prepareServiceCallNode}
                    />
                </div>
            </Paper>
        );
    }
}

const mapStateToProps = state => {
    return {
        companyInfo:    state.companyInfo,
        selectedClient: state.client.selectedClient,
        tree:           state.architect.tree
    };
};

const mapDispatchToProps = {
    ...ArchitectActions,
    ...ClientActions,
    ...CoreActions,
    ...HomeActions,
    ...SiteActions,
    ...SvcRequestActions
};

export default connect(mapStateToProps, mapDispatchToProps)(TreePanel);
